<template>
  <v-container fluid class="pa-0">
    <v-row no-gutters>
      <v-col md="3" cols="12"></v-col>
      <v-col md="6" cols="12">
        <v-alert type="error" variant="tonal">Vous êtes connecté avec le compte administrateur {{
          mainStore.authAdmin.adminData.username }}. Ce compte ne vous donne pas accès à l'administration de {{
            mainStore.module.evenement.nom }}. Vous devez vous connecter avec le compte
          associé que Sportips vous a communiqué.</v-alert>
        <div class="d-flex justify-center gap flex-wrap mt-4">
          <div>
            <v-btn @click="mainStore.authAdmin.logout()" color="primary-dark" block class="mt-2" variant="elevated"
              elevation="0"> <v-icon icon="mdi-account-key" class="mr-2"></v-icon> Changer de compte administrateur
            </v-btn>
          </div>
          <div>
            <router-link class="sm-fullwidth" :to="{ name: 'Home' }">
              <v-btn color="primary-dark" block class="mt-2" variant="outlined"> <v-icon
                  icon="mdi-arrow-left-bold"></v-icon> Retour à l'accueil </v-btn>
            </router-link>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapStores } from 'pinia';
import { useMainStore } from '@/stores/mainStore';
export default {
  computed: {
    ...mapStores(useMainStore),
  },
};
</script>

<style lang="scss" scoped></style>